import { Grid } from '@mui/material';
import ConfigurationField from './ConfigurationField';
import SectionHeader from './SectionHeader';
import {
  SECTION_BOTTOM_MARGIN,
  SECTION_GRID_SPACING,
} from '../paymentsManagerConfiguration.constants';

const ServerDetailsSection = ({ form, fieldErrors, onChange, disabled }) => (
  <>
    <SectionHeader>Server details</SectionHeader>
    <Grid
      container
      spacing={SECTION_GRID_SPACING}
      sx={{ mb: SECTION_BOTTOM_MARGIN }}>
      <Grid item xs={12} md={6}>
        <ConfigurationField
          name='host'
          label='Host'
          value={form.host}
          onChange={onChange}
          error={fieldErrors.host}
          disabled={disabled}
          tooltip='SFTP server hostname or IP address'
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ConfigurationField
          name='port'
          label='Port'
          value={form.port}
          onChange={onChange}
          error={fieldErrors.port}
          type='number'
          disabled={disabled}
          tooltip='SFTP server port'
        />
      </Grid>
    </Grid>
  </>
);

export default ServerDetailsSection;
